<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <div class="mt-4 text-center">
      <BaseCard heading="Nueva Asignación de Campamento">
        <v-card-text>
          <v-row>
            <v-col lg="6" md="6" sm="6" class="col-12">
              <v-text-field :value="nombreTrabajador" label="Trabajador" regular readonly></v-text-field>
            </v-col>
            <v-col lg="3" md="3" sm="3" class="col-8">
              <v-text-field :value="planilla" label="Planilla" regular readonly></v-text-field>
            </v-col>
            <v-col lg="2" md="2" sm="2" class="col-4">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn small v-on="on" fab dark color="primary" @click="openDialog()">
                    <v-icon small dark>fas fa-search</v-icon>
                  </v-btn>
                </template>
                <span>Buscar Trabajador</span>
              </v-tooltip>
            </v-col>
            <EmpleadosListado
              :selected="true"
              :dialog="dialog"
              @asignarEmpleados="seleccionEmpleado($event)"
              @cancelar="cancelarDialogo()"
            ></EmpleadosListado>
          </v-row>
          <v-divider></v-divider>
          <v-row v-if="nombreTrabajador != ''">
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="sector" :items="sectorOpciones" label="Sector"></v-select>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="bloque" :items="bloqueOpciones" label="Bloque"></v-select>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="aldea" :items="aldeaOpciones" label="Aldea"></v-select>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="carpa" :items="carpaOpciones" label="Carpa"></v-select>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="habitacion" :items="habitacionOpciones" label="Habitacion"></v-select>
            </v-col>
            <v-col lg="4" md="4" sm="4" class="col-12">
              <v-select class="px-4" v-model="cama" :items="camaOpciones" label="Cama"></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelar()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </BaseCard>
      <div v-if="showLoading" class="progress-background">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-snackbar v-model="snackbar" timeout="3000">
        {{ text }}
        <v-btn color="info" text @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import AsignacionService from '../services/AsignacionService';
export default {
  name: 'AsignacionFormulario',
  components: {
    EmpleadosListado: () => import('./EmpleadosListado')
  },
  data: () => ({
    snackbar: false,
    text: '',
    showLoading: false,
    asignacionService: null,
    dialog: false,
    nombreTrabajador: '',
    trabajador: [],
    sexo: '',
    planilla: '',
    sector: '',
    sectorOpciones: [],
    bloque: '',
    bloqueOpciones: [],
    aldea: '',
    aldeaOpciones: [],
    carpa: '',
    carpaOpciones: [],
    habitacion: '',
    habitacionOpciones: [],
    cama: '',
    camaOpciones: [],
    unidadCampamento: '',
    page: {
      title: 'Campamento'
    },
    breadcrumbs: [
      {
        text: 'Asignación de Empleados',
        disabled: true
      },
      {
        text: 'Lista de Empleados Asignados',
        disabled: true
      },
      {
        text: 'Asignar',
        disabled: true
      }
    ]
  }),
  watch: {
    nombreTrabajador(val) {
      if (val != '') {
        this.open();
        this.iniciaSectorPadre();
      }
    },
    sector(val) {
      if (val != '') {
        this.open();
        this.iniciaBloque(val);
      }
    },
    bloque(val) {
      if (val != '') {
        this.open();
        this.iniciaAldea(val);
      }
    },
    aldea(val) {
      if (val != '') {
        this.open();
        this.iniciaCarpa(val);
      }
    },
    carpa(val) {
      if (val != '') {
        this.open();
        this.iniciaHabitacion();
      }
    },
    habitacion(val) {
      if (val != '') {
        this.open();
        this.iniciaCama();
      }
    },
    cama(val) {
      this.camaOpciones.forEach((element) => {
        if (element.value == val) {
          this.unidadCampamento = element.unidadCampamento;
        }
      });
    }
  },
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    },
    openDialog() {
      this.dialog = true;
    },
    cancelarDialogo() {
      this.dialog = false;
    },
    async iniciaSectorPadre() {
      this.sector = '';
      this.sectorOpciones = [];
      const res = await this.asignacionService.get().execResource('sectoresPadres', {
        idempresa: localStorage.getItem('emp')
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.sectorOpciones.push({ text: element.idsectorpadre, value: element.idsectorpadre });
        });
        this.sector = this.sectorOpciones[0].value;
      }
      if (this.sectorOpciones.length == 0) {
        this.close();
      }
    },
    async iniciaBloque(env) {
      this.bloque = '';
      this.bloqueOpciones = [];
      const res = await this.asignacionService.get().execResource('sectores', {
        idsectorpadre: env,
        idplanilla: this.planilla.trim(),
        sexo: this.sexo
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.bloqueOpciones.push({
            text: element.idsector,
            value: element.idsector
          });
        });
        this.bloque = this.bloqueOpciones[0].value;
      }
      if (this.bloqueOpciones.length == 0) {
        this.close();
      }
    },
    async iniciaAldea() {
      this.aldea = '';
      this.aldeaOpciones = [];
      const res = await this.asignacionService.get().execResource('aldeas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idplanilla: this.planilla.trim(),
        sexo: this.sexo
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.aldeaOpciones.push({ text: element.nombre, value: element.idaldea });
        });
        this.aldea = this.aldeaOpciones[0].value;
      }
      if (this.aldeaOpciones.length == 0) {
        this.close();
      }
    },
    async iniciaCarpa() {
      this.carpa = '';
      this.carpaOpciones = [];
      const res = await this.asignacionService.get().execResource('carpas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idaldea: this.aldea,
        idplanilla: this.planilla.trim(),
        sexo: this.sexo
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.carpaOpciones.push({ text: element.nombre, value: element.idcarpa });
        });
        this.carpa = this.carpaOpciones[0].value;
      }
      if (this.carpaOpciones.length == 0) {
        this.close();
      }
    },
    async iniciaHabitacion() {
      this.habitacion = '';
      this.habitacionOpciones = [];
      const res = await this.asignacionService.get().execResource('habitaciones', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idaldea: this.aldea,
        idcarpa: this.carpa,
        idplanilla: this.planilla.trim(),
        sexo: this.sexo
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.habitacionOpciones.push({ text: element.nombre, value: element.idhabitacion });
        });
        this.habitacion = this.habitacionOpciones[0].value;
      }
      if (this.habitacionOpciones.length == 0) {
        this.close();
      }
    },
    async iniciaCama() {
      this.cama = '';
      this.camaOpciones = [];
      const res = await this.asignacionService.get().execResource('camas', {
        idempresa: localStorage.getItem('emp'),
        idsectorpadre: this.sector,
        idsector: this.bloque,
        idaldea: this.aldea,
        idcarpa: this.carpa,
        idhabitacion: this.habitacion,
        idplanilla: this.planilla.trim(),
        sexo: this.sexo
      });
      if (res.length > 0) {
        res.forEach((element) => {
          this.camaOpciones.push({
            text: element.nombre,
            value: element.idcama,
            unidadCampamento: element.idunidadcampamento
          });
        });
        this.cama = this.camaOpciones[0].value;
      }
      this.close();
    },
    async seleccionEmpleado(val) {
      this.sexo = val[0].sexo;
      this.trabajador = val[0];
      this.nombreTrabajador = val[0].nombresall;
      this.planilla = val[0].planillafipe;
      this.cancelarDialogo();
    },
    cancelar() {
      this.$router.push({ path: '/campamento/asignacion' });
    },
    async guardar() {
      if (this.nombreTrabajador != '') {
        const res = await this.asignacionService.get().execResource('unidadcampamento', {
          idunidadcampamento: this.unidadCampamento
        });
        if (res.length > 0) {
          const empleadoAsignadoCampamento = [];
          empleadoAsignadoCampamento.push({
            idunidadcampamento: res[0].idunidadcampamento,
            idtrabajador: this.trabajador.idtrabajador,
            nombres: this.trabajador.nombresall,
            sexo: this.trabajador.sexo,
            tipocampamento: res[0].idtipocampamento,
            sectorpadre: res[0].idsectorpadre,
            sector: res[0].idsector,
            aldea: res[0].aldea,
            carpa: res[0].carpa,
            habitacion: res[0].habitacion,
            cama: res[0].cama,
            csexo: res[0].sexounid,
            iniciocontrato: this.trabajador.iniciocontrato,
            fincontrato: this.trabajador.fincontrato,
            idempresa: this.trabajador.idempresa,
            idasistenciafipe: this.trabajador.idasistencia,
            periodo: this.trabajador.periodo,
            idplanilla: this.trabajador.planillatrabajador,
            diascontrato: this.trabajador.diascontrato,
            fincampamento: this.trabajador.fincampamento,
            idusuariofipe: this.trabajador.idusuarioaprobador,
            fecha: this.trabajador.fecha,
            hora: this.trabajador.hora,
            error: false
          });
          const response = await this.asignacionService.post().execResource('asignardistribucion', {
            exportacion: [...empleadoAsignadoCampamento]
          });
          if (response.status) {
            this.text = response.message;
            this.snackbar = true;
            this.trabajador = [];
            this.nombreTrabajador = '';
            this.planilla = '';
            this.sexo = '';
          } else {
            this.text = 'Error al intentar guardar';
            this.snackbar = true;
          }
        }
      }
    }
  },
  async mounted() {
    this.asignacionService = this.$httpService(new AsignacionService(), this);
  }
};
</script>
